import React from "react";
import { useMediaQuery, Box, Text, Flex, Image } from "@chakra-ui/react";
import { colors } from "../../definitions/constants/GlobalStyles";
import {
  AuthorProps,
  CommentsData,
} from "../../definitions/interfaces/GlobalInterfaces";
import CommentAuthorComponent from "./CommentAuthorComponent";
import { postStore } from "../../zustand/globalStore";

function CommentsList({ post }: AuthorProps) {
  const [isMobile] = useMediaQuery("(max-width: 992px)");
  const CommentsMax = 4;
  const { setShowCommentsModal, setSelectedPost } = postStore((state) => state);

  const comments = post?.comments || [];

  return (
    <>
      <Box>
        {comments.length > CommentsMax
          ? comments
            .slice(0, CommentsMax)
            .map((comment: CommentsData, index: number) => (
              <CommentAuthorComponent key={index} comment={comment} />
            ))
          : comments.map((comment: CommentsData, index: number) => (
            <CommentAuthorComponent key={index} comment={comment} />
          ))}
      </Box>

      <Flex
        paddingLeft={isMobile ? "30px" : "0"}
        marginBottom={2}
        onClick={() => {
          setSelectedPost(post);
          setShowCommentsModal(true);
        }}
        cursor="pointer"
      >
        {comments.length >= CommentsMax + 1 &&
          comments[CommentsMax + 1] ? (
          <Image
            boxSize="25px"
            borderRadius="100%"
            src={comments[CommentsMax + 1].image_url}
          />
        ) : null}
        {comments.length >= CommentsMax + 2 &&
          comments[CommentsMax + 2] ? (
          <Image
            boxSize="25px"
            borderRadius="100%"
            src={comments[CommentsMax + 2].image_url}
          />
        ) : null}
        {comments.length > CommentsMax ? (
          <Box
            bg={colors.figmaColors.secColor}
            boxSize="25px"
            borderRadius="full"
          >
            <Flex align="center" justifyContent="center" height="100%">
              <Text color={colors.text.white} fontWeight={600} fontSize="11px">
                +{comments.length - CommentsMax}
              </Text>
            </Flex>
          </Box>
        ) : null}
      </Flex>
    </>
  );
}

export default CommentsList;
